import {fromJS} from 'immutable';

const defState = fromJS({
    'EDIT': {
        //lv: 'Labot',
    },
    'REMOVE': {
        //lv: 'Dzēst',
    },
    'SUMMARY': {
        //lv: 'Kopsavilkums',
    },
    'SUBMIT_WORK_REPORT': {
        //lv: 'Iesniegt darba atskaiti',
    },
    'WORK_ACCOUNTING_CALENDAR': {
        //lv: 'Darbu uzskaites kalendārs',
    },
    'COMPLETE_WINDOWS_WAREHOUSE': {
        ru: 'Склад готовых окон',
    },
});

export default function reducer(state = defState, action) {
    switch (action.type) {
        default:
            return state;
    }
};